import { useEffect, useState } from "react";
import Cards from "../../components/common/card/Card";
import TopSection from "../LT/TopSection";
import { PowerBIEmbed } from 'powerbi-client-react';
import { models } from 'powerbi-client';
import { getPowerBIConfig } from "../../redux/actions/PowerBIReports/GetPowerBIReportsSlice";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { Loader } from "../../components/common/Loader";
import { Box, CircularProgress } from "@mui/material";

const PowerBIReports = () => {
    const dispatch = useDispatch();
    const stateSelector = useSelector((state) => state);
    const [activeItem, setActiveItem] = useState(localStorage.getItem("reportsActiveItem") || "Lead Time Variations at Component Level");
    const [powerBIAccessToken, setPowerBIAccessToken] = useState("");
    const [powerBIEmbedURL, setPowerBIEmbedURL] = useState("");
    const [powerBIReportID, setPowerBIReportID] = useState("");

    const cardData = [
        { title: "Lead Time Variations at Component Level" },
        { title: "Transportation-Lead Time Variation" },
        { title: "Lead Time Workflow Status" },
        { title: "Contracts Data Quality Check" },
        { title: "PO Visibility" },
        { title: "Job Run Summary" },
        { title: "PO Adherence Report" }
    ];
    const callBackFunction = (index, title, url) => {
        setActiveItem(title);
        localStorage.setItem("reportsActiveItem", title)
    }
    const filter = [
        {
            $schema: "http://powerbi.com/product/schema#basic",
            target: {
                table: "Query1",
                column: activeItem === "PO Visibility" ? "PLANT_POITEM" : "Plant",
            },
            operator: "Equals",
            values: [localStorage.getItem("selectedLTPlantCode")],
            filterType: models.FilterType.Basic,
            requireSingleSelection: true
        },
    ];
    const filterAllPlants = [
        {
            $schema: "http://powerbi.com/product/schema#basic",
            target: {
                table: "Query1",
                column: "COKEREGION",
            },
            operator: "Equals",
            values: [localStorage.getItem("LTRegion")],
            filterType: models.FilterType.Basic,
            requireSingleSelection: true
        },
    ];
    const embedConfig = {
        type: 'report',
        id: powerBIReportID,
        embedUrl: `${powerBIEmbedURL}`,
        accessToken: powerBIAccessToken,
        tokenType: models.TokenType.Embed,
        settings: {
            panes: {
                filters: {
                    expanded: false,
                    visible: false,
                },
            },
            navContentPaneEnabled: false,
            layoutType: models.LayoutType.Custom,
            customLayout: {
                displayOption: models.DisplayOption.FitToWidth,
            },
        },
        filters: localStorage.getItem("selectedLTPlantCode") === "All" ? filterAllPlants : filter
    }
    const transportReportID = process.env.REACT_APP_PBI_TRANSPORTATION_LT_VARIATION_REPORT_ID
    const workflowReportID = process.env.REACT_APP_PBI_LT_WORKFLOW_STATUS_REPORT_ID
    const contractReportID = process.env.REACT_APP_PBI_CONTRACTS_DATA_QUALITY_CHECK_REPORT_ID
    const componentReportID = process.env.REACT_APP_PBI_COMPONENT_LEVEL_REPORT_ID
    const poVisibilityReportID = process.env.REACT_APP_PBI_LT_PO_VISIBILITY_REPORT_ID
    const jobRunSummaryReportID = process.env.REACT_APP_PBI_LT_JOB_RUN_SUMMARY_REPORT_ID
    const poAdherenceReportID = process.env.REACT_APP_PBI_LT_PO_ADHERENCE_REPORT_ID

    const transportGroupID = process.env.REACT_APP_PBI_TRANSPORTATION_LT_VARIATION_GROUP_ID
    const workflowGroupID = process.env.REACT_APP_PBI_LT_WORKFLOW_STATUS_GROUP_ID
    const contractGroupID = process.env.REACT_APP_PBI_CONTRACTS_DATA_QUALITY_CHECK_GROUP_ID
    const componentGroupID = process.env.REACT_APP_PBI_COMPONENT_LEVEL_GROUP_ID
    const poVisibilityGroupID = process.env.REACT_APP_PBI_LT_PO_VISIBILITY_GROUP_ID
    const jobRunSummaryGroupID = process.env.REACT_APP_PBI_LT_JOB_RUN_SUMMARY_GROUP_ID
    const poAdherenceGroupID = process.env.REACT_APP_PBI_LT_PO_ADHERENCE_GROUP_ID 

    useEffect(() => {
        const reportID = activeItem === "Transportation-Lead Time Variation" ? transportReportID : activeItem === "Lead Time Workflow Status" ? workflowReportID : activeItem === "Contracts Data Quality Check" ? contractReportID : activeItem === "PO Visibility" ? poVisibilityReportID : activeItem === "Job Run Summary" ? jobRunSummaryReportID : activeItem === "PO Adherence Report" ? poAdherenceReportID : componentReportID;
        const groupID = activeItem === "Transportation-Lead Time Variation" ? transportGroupID : activeItem === "Lead Time Workflow Status" ? workflowGroupID : activeItem === "Contracts Data Quality Check" ? contractGroupID : activeItem === "PO Visibility" ? poVisibilityGroupID : activeItem === "Job Run Summary" ? jobRunSummaryGroupID : activeItem === "PO Adherence Report" ? poAdherenceGroupID : componentGroupID;

        const getPowerBIActionDashboardDetails = async () => {
            try {
                const responsePowerBIActionDashboardDetails = await dispatch(getPowerBIConfig({
                    dynamicEndpoint: `api/powerBI/embedDetails/group/${groupID}/report/${reportID}`,
                    params: {
                        plant: localStorage.getItem("selectedLTPlantCode")
                    }
                }));
                if (responsePowerBIActionDashboardDetails?.meta?.requestStatus === 'fulfilled') {
                    setPowerBIEmbedURL(responsePowerBIActionDashboardDetails?.payload?.embedUrl);
                    setPowerBIReportID(responsePowerBIActionDashboardDetails?.payload?.reportId);
                    setPowerBIAccessToken(responsePowerBIActionDashboardDetails?.payload?.accessToken)
                } else {
                    toast.error(responsePowerBIActionDashboardDetails?.payload?.errorMessage, {
                        autoClose: 2000,
                    });
                }
            } catch (error) {
                console.error('API error:', error);
            }
        }
        getPowerBIActionDashboardDetails();

    }, [activeItem]);

    return (
        <div>
            <TopSection
                labelList={[
                    { title: "Home", path: "/landing-page" },
                    { title: "Reports" },
                ]}
                tabTitle="Reports"
            />
            <div className="container">
                <Cards cards={cardData} showBorder={true} callBackFunction={callBackFunction} />
            </div>
            {stateSelector?.GetPowerBIReportsSlice?.loading ?
                <div>
                    <Box style={{
                        width: '100%',
                        height: '40vh',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }} >
                        <CircularProgress color="inherit" />
                    </Box>
                </div> :
                <div className="powerBi_cls">
                    {embedConfig?.embedUrl && embedConfig?.accessToken &&
                        <PowerBIEmbed
                            embedConfig={embedConfig}
                        />}
                </div>
            }
        </div>
    )
}

export default PowerBIReports;
